import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';

import { getUserPortfoliosForLayout } from '~/database/supabase/portfolio/queries.server.ts';
import type { PortfolioForLayoutType } from '~/database/supabase/portfolio/types.ts';

import { requireStartAuthSession } from '../auth/require-start-auth-session.ts';
import { createServerFnObservabilityMiddleware } from '../utils/create-instrumented-server-fn.ts';
import { measureServerTiming } from '../utils/server-timing.ts';

export const getPortfolioLayoutData = createServerFn({ method: 'GET' })
	.middleware([
		createServerFnObservabilityMiddleware({
			dependencies: ['auth.session', 'supabase.portfolio.layout'],
			relatesTo: 'portfolio.layout',
		}),
	])
	.handler(async (): Promise<PortfolioForLayoutType[] | null> => {
		const request = getRequest();
		const authSession = await measureServerTiming({
			description: 'auth.session',
			name: 'portfolio-layout-auth',
			run: () => requireStartAuthSession({ request }),
		});

		return measureServerTiming({
			description: 'supabase.portfolio.layout',
			name: 'portfolio-layout-portfolios',
			run: () => getUserPortfoliosForLayout(authSession.userId),
		});
	});
